import { UserGroup, UserType } from '@/types';

export class User {
  constructor(
    public id: string,
    public email: string,
    public language: string,
    public firstName: string,
    public lastName: string,
    public country: string,
    public phone: string,
    public allowWebWallets: boolean,
    public userGroup: UserGroup,
  ) {}

  static createFromData({
    id,
    email,
    language,
    firstName,
    lastName,
    country,
    phone,
    allowWebWallets,
    userGroup,
  }): User {
    return new User(
      id,
      email,
      language,
      firstName,
      lastName,
      country,
      phone,
      allowWebWallets,
      userGroup,
    );
  }

  get userType() {
    if (!this.userGroup) return undefined;

    if (this.userGroup === UserGroup.CORPORATE) {
      return UserType.CORPORATE;
    }

    return UserType.PRIVATE;
  }
}
